import { DictionaryEntry } from '@sdbn/common';

export class IssueTypeDetails {
  id: number;
  name: DictionaryEntry;
  sortOrder: string;
  delay: number;
}


